import { AtlasMark, Icon } from '../icons';
import { formatBytes, formatTimeAgo } from '../utils';

export const NAV_ITEMS = [
  ['overview', 'Overview'], ['graph', 'Graph'], ['knowledge', 'Knowledge'], ['timeline', 'Timeline'], ['history', 'History'], ['sources', 'Sources'], ['skills', 'Skills'], ['fleet', 'Fleet'],
];

export function Sidebar({ view, onView, data }) {
  return (
    <aside className="sidebar sidebar--refined">
      <button className="brand brand--quiet" onClick={() => onView('overview')} aria-label="Codex Memory Atlas overview"><AtlasMark size={34}/><span>Codex<br/>Memory Atlas</span></button>
      <nav className="sidebar__nav" aria-label="Memory views">
        {NAV_ITEMS.map(([id,label]) => <button key={id} className={view === id ? 'is-active' : ''} onClick={() => onView(id)}><Icon name={id} size={19}/><span>{label}</span></button>)}
      </nav>
      <div className="sidebar__meta sidebar__meta--quiet">
        <p><span className={`host-dot host-dot--${data.host?.state || 'ready'}`}/>{data.host?.label || 'This Mac'}</p>
        <code>{data.host?.hostname || 'local'}</code>
        <small>{data.metrics.sourceFiles} files · {formatBytes(data.metrics.totalBytes)}</small>
        <small title="Most recent memory timestamp">Latest memory {formatTimeAgo(data.host?.sourceUpdatedAt || data.updatedAt)}</small>
      </div>
    </aside>
  );
}

export function MobileNav({ view, onView }) {
  const mobileItems = [['overview','Overview'],['graph','Graph'],['history','History'],['fleet','Fleet'],['sources','Sources']];
  return <nav className="mobile-nav" aria-label="Memory views">{mobileItems.map(([id,label]) => <button key={id} className={view === id ? 'is-active' : ''} onClick={() => onView(id)}><Icon name={id} size={22}/><span>{label}</span></button>)}</nav>;
}
